import { queryKeyFactory } from '~/app/auth/queries/query-key-factory';
import { queryClient } from '~/infrastructure/query-client';

export function useIsImpersonating() {
	return queryClient.getQueryData<{ impersonating: boolean }>(queryKeyFactory.checkAuthentication())?.impersonating;
}
